import { io } from 'socket.io-client';
const SOCKET_URL = 'https://aia-backend-production.up.railway.app';
let socket = null;
export const initSocket = (token) => {
  socket = io(SOCKET_URL, {
    auth: { token },
    transports: ['websocket'],
    reconnection: true,
    reconnectionDelay: 1000,
  });
  socket.on('connect', () => console.log('🔌 Socket connected'));
  socket.on('disconnect', () => console.log('🔌 Socket disconnected'));
  return socket;
};
export const getSocket = () => socket;
export const disconnectSocket = () => {
  if (socket) { socket.disconnect(); socket = null; }
};
export default { initSocket, getSocket, disconnectSocket };
